import area_0_banner_img from '@/assets/images/transmission_template/area_0_banner.jpeg'
import area_0_image_1_img from '@/assets/images/transmission_template/area_0_image_1.jpeg'
import area_0_image_2_img from '@/assets/images/transmission_template/area_0_image_2.jpg'
import area_1_banner_img from '@/assets/images/transmission_template/area_1_banner.jpg'
import area_1_image_1_img from '@/assets/images/transmission_template/area_1_image_1.jpeg'
import area_1_image_2_img from '@/assets/images/transmission_template/area_1_image_2.jpeg'
import area_1_image_3_img from '@/assets/images/transmission_template/area_1_image_3.jpeg'
import area_1_image_4_img from '@/assets/images/transmission_template/area_1_image_4.jpeg'
import area_2_banner_img from '@/assets/images/transmission_template/area_2_banner.jpeg'
import area_2_image_1_img from '@/assets/images/transmission_template/area_2_image_1.jpeg'
import area_2_image_2_img from '@/assets/images/transmission_template/area_2_image_2.jpeg'
import area_2_image_3_img from '@/assets/images/transmission_template/area_2_image_3.jpeg'
import area_2_image_4_img from '@/assets/images/transmission_template/area_2_image_4.jpeg'
import area_3_banner_img from '@/assets/images/transmission_template/area_3_banner.jpeg'
import area_3_image_1_img from '@/assets/images/transmission_template/area_3_image_1.jpeg'
import area_3_image_2_img from '@/assets/images/transmission_template/area_3_image_2.jpeg'
import area_3_image_3_img from '@/assets/images/transmission_template/area_3_image_3.jpeg'
import area_4_banner_img from '@/assets/images/transmission_template/area_4_banner.jpg'
import area_4_image_1_img from '@/assets/images/transmission_template/area_4_image_1.jpeg'
import area_4_image_2_img from '@/assets/images/transmission_template/area_4_image_2.jpeg'


const areaList = [
  {
    id: 0,
    title: '展覽緣起',
    contentLines: [
      '從平溪山林到萬里靈泉，從中台禪寺到海內外一間間精舍，開山祖師惟覺安公老和尚以無盡悲願廣度眾生：讓更多人在生活中接觸佛法，契悟清淨心，找到人生安身立命的地方。',
      '1991 年「中華民國中台禪會」成立後，海內外分院精舍陸續在各地建立。它們有的位於熱鬧街區，有的座落海外城市，每一個精舍都是具足佛法僧三寶的修行空間，承載著許多人共同護持、學習與傳承佛法的歷程。每一間精舍的出現，都是佛法走入人群、陪伴大眾修行的具體見證。',
      '本展以「法水長流」為主軸，帶領觀者回望中台禪寺所屬精舍從開創、發展，到面對時代挑戰與持續前行的歷程。',
    ],
    bannerImg: area_0_banner_img,
    image1: area_0_image_1_img,
    image2: area_0_image_2_img,
    image3: null,
    image4: null,
    text1: null,
    text2: null,
    text3: null,
    text4: null,
  },
  {
    id: 1,
    title: '溯源・啟航',
    contentLines: [
      '隨著現代物質文明發達，人心卻日益空虛不安。開山祖師惟覺安公老和尚洞察人心不安，來自精神生活的匱乏，秉持「但願眾生得離苦」之大悲願力，早在平溪十方圓明禪林及靈泉寺草創之初，便嘗試以佛學課程接引大眾，讓大眾透過佛法把心安定下來，找到自性光明。1991 年「中華民國中台禪會」正式成立，老和尚秉持回饋社會、禪法利生的悲願，於海內外廣設分院及精舍，開設免費禪修課程，大展「中台廣傳」的法筵。',
    ],
    bannerImg: area_1_banner_img,
    image1: area_1_image_1_img,
    image2: area_1_image_2_img,
    image3: area_1_image_3_img,
    image4: area_1_image_4_img,
    text1: '全覽',
    text2: '弘揚起源',
    text3: '平溪初開',
    text4: '萬行弘化',
  },
  {
    id: 2,
    title: '弘法・現況',
    contentLines: [
      '為了讓忙碌的現代人就近熏習佛法，得到禪修的利益，老和尚發願於都市中廣設道場，教導禪修，以佛法端正知見。從板橋普明精舍為發端，緊接著有居士供養台北市吳興街一處位於五樓的房舍，開山祖師派任法師住持弘法，1992 年 4月19日，中台禪寺第一家分院——普光精舍成立，禪修班正式開課。',
      '受到老和尚的悲心願力感召，蒙受法益的居士們陸續發心、布施房舍，各地分院——應緣而生，遍及海內外。本區展出各分院精舍之弘法軌跡、袖珍模型及代表性物件，呈現法師與居士們如何隨順因緣，於不同水土中，耕耘出各具特色的弘法氣象，順應眾生根機，將禪宗心法流布十方。',
    ],
    bannerImg: area_2_banner_img,
    image1: area_2_image_1_img,
    image2: area_2_image_2_img,
    image3: area_2_image_3_img,
    image4: area_2_image_4_img,
    text1: null,
    text2: null,
    text3: null,
    text4: null,
  },
  {
    id: 3,
    title: '轉折・挑戰',
    contentLines: [
      '2019年末，全球新冠疫情如狂風驟雨，海內外精舍實體的共修及課程因防疫考量而暫緩。儘管如此，中台禪寺沒有因此停下腳步，反而積極優化道場硬體建設，提升弘法功能',
    ],
    bannerImg: area_3_banner_img,
    image1: area_3_image_1_img,
    image2: area_3_image_2_img,
    image3: area_3_image_3_img,
    text1: null,
    text2: null,
    text3: null,
    text4: null,
  },
  {
    id: 4,
    title: '傳承・未來',
    contentLines: [
      '開山祖師曾開示：「中台山是一個大的航空母艦，精舍法師要回山參加禪修、住持講習，回來充電；精舍的居士要回來交流，參加山上舉辦的種種活動。這些都很重要！只要一心向道，就能得解脫！」',
      '回望來時路，每一步行履，皆是開山祖師不捨一眾生的慈悲示現。從靈泉到中台，從山林到都市，老和尚一生。',
    ],
    bannerImg: area_4_banner_img,
    image1: area_4_image_1_img,
    image2: area_4_image_2_img,
    text1: null,
    text2: null,
    text3: null,
    text4: null,
  }
]

// 01模板
const templateDetail_01 = {
  "theme": {
    "colorId": 0
  },
  "blocks": [
    {
      "id": "uuid-banner-1",
      "data": {
        "mobile": {
          "url": "",
          "media_id": 654
        },
        "desktop": {
          "url": "",
          "media_id": null
        }
      },
      "type": "banner",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-title-1",
      "data": {
        "value": ""
      },
      "type": "title",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-content-1",
      "data": {
        "value": ""
      },
      "type": "text",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-section-3",
      "data": { "value": "展區\n剪影" },
      "type": "title",
      "layout": { "w": 12 },
      "editable": false,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-1",
      "data": {
        "url": "https://.jpg",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-1",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-2",
      "data": {
        "url": "https://.jpg",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-2",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-3",
      "data": {
        "url": "https://.jpg",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-3",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-4",
      "data": {
        "url": "https://.jpg",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-4",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    }
  ],
  "settings": {
    "intro": { "gradient": true },
    "modelTitleStyle": "left",
    "silhouetteVariant": 1,
    "artifactTitleStyle": "left",
    "modelImagePosition": "left",
    "artifactImagePosition": "right"
  }
}
// 02模板
const templateDetail_02 = {
  "theme": {
    "colorId": 1
  },
  "blocks": [
    {
      "id": "uuid-banner-1",
      "data": {
        "mobile": {
          "url": "",
          "media_id": null
        },
        "desktop": {
          "url": "",
          "media_id": null
        }
      },
      "type": "banner",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-title-1",
      "data": {
        "value": ""
      },
      "type": "title",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-content-1",
      "data": {
        "value": ""
      },
      "type": "text",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-section-3",
      "data": { "value": "展場\n剪影" },
      "type": "title",
      "layout": { "w": 12 },
      "editable": false,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-1",
      "data": {
        "url": "https://.jpg",
        "caption": "",
        "fullUrl": "",
        "media_id": null,
        "full_media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-1",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-2",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-2",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-3",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-3",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-4",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-4",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    }
  ],
  "settings": {
    "intro": { "gradient": true },
    "templateId": 2,
    "modelTitleStyle": "left",
    "silhouetteVariant": 6,
    "artifactTitleStyle": "left",
    "modelImagePosition": "right",
    "modelSubtitleAlign": "left",
    "artifactImagePosition": "left"
  }
}
// 03模板
const templateDetail_03 = {
  "theme": {
    "colorId": 2
  },
  "blocks": [
    {
      "id": "uuid-banner-1",
      "data": {
        "mobile": {
          "url": "",
          "media_id": null
        },
        "desktop": {
          "url": "",
          "media_id": null
        }
      },
      "type": "banner",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-title-1",
      "data": {
        "value": ""
      },
      "type": "title",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-content-1",
      "data": {
        "value": ""
      },
      "type": "text",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-section-3",
      "data": { "value": "展區\n剪影" },
      "type": "title",
      "layout": { "w": 12 },
      "editable": false,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-1",
      "data": {
        "url": "https://.jpg",
        "caption": "",
        "fullUrl": "",
        "media_id": 752,
        "full_media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-1",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-2",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-2",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-3",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-3",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-4",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-4",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    }
  ],
  "settings": {
    "intro": { "gradient": false },
    "templateId": 3,
    "silhouetteText": "below",
    "modelTitleStyle": "left",
    "silhouetteVariant": 5,
    "artifactTitleStyle": "left",
    "modelImagePosition": "right",
    "modelSubtitleAlign": "left",
    "artifactImagePosition": "left"
  }
}
// 04模板
const templateDetail_04 = {
  "theme": {
    "colorId": 3
  },
  "blocks": [
    {
      "id": "uuid-banner-1",
      "data": {
        "mobile": {
          "url": "",
          "media_id": null
        },
        "desktop": {
          "url": "",
          "media_id": null
        }
      },
      "type": "banner",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-title-1",
      "data": {
        "value": ""
      },
      "type": "title",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-content-1",
      "data": {
        "value": ""
      },
      "type": "text",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-section-3",
      "data": { "value": "展場\n剪影" },
      "type": "title",
      "layout": { "w": 12 },
      "editable": false,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-1",
      "data": {
        "url": "https://.jpg",
        "caption": "",
        "fullUrl": "",
        "media_id": null,
        "full_media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-1",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-2",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-2",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-3",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-3",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-4",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-4",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    }
  ],
  "settings": {
    "intro": { "gradient": false },
    "modelBg": "none",
    "artifactBg": "none",
    "templateId": 4,
    "silhouetteText": "below",
    "modelTitleStyle": "left",
    "silhouetteNumber": true,
    "silhouetteVariant": 7,
    "artifactTitleStyle": "left",
    "modelImagePosition": "left",
    "modelSubtitleAlign": "right",
    "artifactImagePosition": "right"
  }
}
// 05模板
const templateDetail_05 = {
  "theme": {
    "colorId": 4
  },
  "blocks": [
    {
      "id": "uuid-banner-1",
      "data": {
        "mobile": {
          "url": "https://.png",
          "media_id": null
        },
        "desktop": {
          "url": "",
          "media_id": null
        }
      },
      "type": "banner",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-title-1",
      "data": {
        "value": "<p></p>"
      },
      "type": "title",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-content-1",
      "data": {
        "value": "<p></p>"
      },
      "type": "text",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-section-3",
      "data": { "value": "展場\n剪影" },
      "type": "title",
      "layout": { "w": 12 },
      "editable": false,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-1",
      "data": {
        "url": "https://.png",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-1",
      "data": {
        "value": "<p></p>"
      },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-2",
      "data": {
        "url": "https://.png",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-2",
      "data": {
        "value": "<p></p>"
      },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-3",
      "data": {
        "url": "https://.png",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-3",
      "data": {
        "value": "<p></p>"
      },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-4",
      "data": {
        "url": "https://.png",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-4",
      "data": {
        "value": "<p></p>"
      },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
  ],
  "settings": {
    "intro": { "gradient": true },
    "modelBg": "none",
    "artifactBg": "none",
    "silhouetteText": "right",
    "modelTitleStyle": "left",
    "silhouetteVariant": 8,
    "artifactTitleStyle": "left",
    "modelImagePosition": "right",
    "modelSubtitleAlign": "left",
    "artifactImagePosition": "right"
  }
}
// 06模板
const templateDetail_06 = {
  "theme": {
    "colorId": 5
  },
  "blocks": [
    {
      "id": "uuid-banner-1",
      "data": {
        "mobile": {
          "url": "",
          "media_id": null
        },
        "desktop": {
          "url": "",
          "media_id": null
        }
      },
      "type": "banner",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-title-1",
      "data": {
        "value": ""
      },
      "type": "title",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-content-1",
      "data": {
        "value": ""
      },
      "type": "text",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-section-3",
      "data": { "value": "展場\n剪影" },
      "type": "title",
      "layout": { "w": 12 },
      "editable": false,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-1",
      "data": {
        "url": "https://.jpg",
        "caption": "",
        "fullUrl": "",
        "media_id": null,
        "full_media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-1",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-2",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-2",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-3",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-3",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-4",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-4",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    }
  ],
  "settings": {
    "intro": { "gradient": false },
    "modelBg": "none",
    "artifactBg": "none",
    "templateId": 6,
    "modelTitleStyle": "line-right",
    "silhouetteVariant": 9,
    "artifactTitleStyle": "line-left",
    "modelImagePosition": "left",
    "modelSubtitleAlign": "center",
    "silhouetteTitleStyle": "line-right",
    "artifactImagePosition": "left"
  }
}
// 07模板
const templateDetail_07 = {
  "theme": {
    "colorId": 6
  },
  "blocks": [
    {
      "id": "uuid-banner-1",
      "data": {
        "mobile": {
          "url": "",
          "media_id": null
        },
        "desktop": {
          "url": "",
          "media_id": null
        }
      },
      "type": "banner",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-title-1",
      "data": {
        "value": ""
      },
      "type": "title",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-content-1",
      "data": {
        "value": ""
      },
      "type": "text",
      "layout": { "w": 12 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-section-3",
      "data": { "value": "展場\n剪影" },
      "type": "title",
      "layout": { "w": 12 },
      "editable": false,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-1",
      "data": {
        "url": "https://.jpg",
        "caption": "",
        "fullUrl": "",
        "media_id": 752,
        "full_media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-1",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-2",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-2",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-3",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-3",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-image-4",
      "data": {
        "url": "",
        "caption": "",
        "media_id": null
      },
      "type": "image",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    },
    {
      "id": "uuid-silhouette-text-4",
      "data": { "value": "" },
      "type": "text",
      "layout": { "w": 7 },
      "editable": true,
      "removable": false
    }
  ],
  "settings": {
    "intro": { "gradient": true },
    "modelBg": "none",
    "artifactBg": "none",
    "templateId": 7,
    "silhouetteVariant": 10,
    "modelImagePosition": "left",
    "modelSubtitleAlign": "center",
    "artifactImagePosition": "left"
  }
}

function getAreaTemplateDetail(areaId, templateId = 1) {
  const area = areaList.find(a => a.id === areaId)
  if (!area) return null

  let template = null
  if (templateId === 1) {
    template = JSON.parse(JSON.stringify(templateDetail_01))
  } else if (templateId === 2) {
    template = JSON.parse(JSON.stringify(templateDetail_02))
  } else if (templateId === 3) {
    template = JSON.parse(JSON.stringify(templateDetail_03))
  } else if (templateId === 4) {
    template = JSON.parse(JSON.stringify(templateDetail_04))
  } else if (templateId === 5) {
    template = JSON.parse(JSON.stringify(templateDetail_05))
  } else if (templateId === 6) {
    template = JSON.parse(JSON.stringify(templateDetail_06))
  } else if (templateId === 7) {
    template = JSON.parse(JSON.stringify(templateDetail_07))
  }

  const bannerBlock = template.blocks.find(b => b.id === 'uuid-banner-1')
  if (bannerBlock) {
    bannerBlock.data.mobile.url = area.bannerImg
    bannerBlock.data.desktop.url = area.bannerImg
  }

  const titleBlock = template.blocks.find(b => b.id === 'uuid-title-1')
  if (titleBlock) {
    titleBlock.data.value = `<p><strong>${area.title}</strong></p>`
  }

  const contentBlock = template.blocks.find(b => b.id === 'uuid-content-1')
  if (contentBlock) {
    const contentText = (area.contentLines ?? []).join('')
    contentBlock.data.value = `<p><span style="font-size: 1.25em;">${contentText}</span></p>`
  }

  const silhouette1 = template.blocks.find(b => b.id === 'uuid-silhouette-image-1')
  if (silhouette1) silhouette1.data.url = area.image1
  const silhouette2 = template.blocks.find(b => b.id === 'uuid-silhouette-image-2')
  if (silhouette2) silhouette2.data.url = area.image2
  const silhouette3 = template.blocks.find(b => b.id === 'uuid-silhouette-image-3')
  if (silhouette3) silhouette3.data.url = area.image3
  const silhouette4 = template.blocks.find(b => b.id === 'uuid-silhouette-image-4')
  if (silhouette4) silhouette4.data.url = area.image4

  const silhouetteText1 = template.blocks.find(b => b.id === 'uuid-silhouette-text-1')
  if (silhouetteText1) silhouetteText1.data.value = area.text1
  const silhouetteText2 = template.blocks.find(b => b.id === 'uuid-silhouette-text-2')
  if (silhouetteText2) silhouetteText2.data.value = area.text2
  const silhouetteText3 = template.blocks.find(b => b.id === 'uuid-silhouette-text-3')
  if (silhouetteText3) silhouetteText3.data.value = area.text3
  const silhouetteText4 = template.blocks.find(b => b.id === 'uuid-silhouette-text-4')
  if (silhouetteText4) silhouetteText4.data.value = area.text4

  const imageKeys = [
    { key: 'image1', imageId: 'uuid-silhouette-image-1', textId: 'uuid-silhouette-text-1' },
    { key: 'image2', imageId: 'uuid-silhouette-image-2', textId: 'uuid-silhouette-text-2' },
    { key: 'image3', imageId: 'uuid-silhouette-image-3', textId: 'uuid-silhouette-text-3' },
    { key: 'image4', imageId: 'uuid-silhouette-image-4', textId: 'uuid-silhouette-text-4' },
  ]

  const removeIds = new Set()
  for (const { key, imageId, textId } of imageKeys) {
    if (area[key] == null) {
      removeIds.add(imageId)
      removeIds.add(textId)
    } else {
      const block = template.blocks.find(b => b.id === imageId)
      if (block) block.data.url = area[key]
    }
  }

  if (removeIds.size > 0) {
    template.blocks = template.blocks.filter(b => !removeIds.has(b.id))
  }

  return template
}

function getAreaResponse(areaId, templateId = 1) {
  const templateDetail = getAreaTemplateDetail(areaId, templateId)

  const res = {
    items: [
      {
        area: '展',
        detail: '',
        has_liked: false,
        image: [
          // 654: banner (templateDetail.blocks.uuid-banner-1.mobile.media_id)
          { cache_url: '', device: 'desktop', media_id: null },
          // 678/679: silhouette images
          { cache_url: '', device: 'desktop', media_id: null },
          { cache_url: '', device: 'desktop', media_id: null },
          { cache_url: '', device: 'desktop', media_id: null },
          { cache_url: '', device: 'desktop', media_id: null },
        ],
        like_count: 2,
        // post_id: 28,
        // published_time: 'Sat, 01 Aug 2026 06:00:00 GMT',
        // status: 4,
        // status_en: 1,
        // title_en: '萬里靈泉寺',
        // video: null,
      },
    ],
    message: 'Success',
    result_code: 200,
  }

  res.items[0].detail = JSON.stringify(templateDetail)
  return res
}

export const mockApiClient = {
  area_detail: async ({ area_id, template_id = 1 }) => {
    const id = Number(area_id)
    // console.log('area_detail', area_id, id)
    if (id !== null && id !== undefined && !isNaN(id) && id >= 0)
      return getAreaResponse(id, template_id)
    return {
      items: [],
      message: 'Success',
      result_code: 200,
    }
  },
}

